/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.centered-spinner[_ngcontent-%COMP%]{margin:auto;text-align:center}.centered-spinner[_ngcontent-%COMP%], .centered-spinner[_ngcontent-%COMP%]   .mat-progress-spinner[_ngcontent-%COMP%]{width:150px;min-width:150px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3V0aWxpdGllcy9jb21wb25lbnRzL3JlcG9ydC1kaWFsb2cvcmVwb3J0LWRpYWxvZy5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL3NyYy9hcHAvbW9kdWxlcy91dGlsaXRpZXMvY29tcG9uZW50cy9yZXBvcnQtZGlhbG9nL3JlcG9ydC1kaWFsb2cuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/utilities/components/report-dialog/report-dialog.component.scss.shim.ngstyle.ts